import { get, ENDPOINTS } from '@/api/mainApi';
import store from '@/store';

export default class LocationService {
  async getUserCountry(): Promise<string | null> {
    const orgGroup = store.state.requestSession?.organizationGroup as
      | { country?: string }
      | undefined;

    if (orgGroup?.country) {
      return orgGroup.country;
    }

    try {
      const country = (await get(ENDPOINTS.USER_LOCATION, undefined, false)) as string;
      return country;
    } catch (error) {
      window.log?.debug('Error fetching user country:', error);
      return null;
    }
  }
}
